/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowNarrowRight = createReactComponent(
  "arrow-narrow-right",
  "IconArrowNarrowRight",
  [
    ["path", { d: "M5 12l14 0", key: "svg-0" }],
    ["path", { d: "M15 16l4 -4", key: "svg-1" }],
    ["path", { d: "M15 8l4 4", key: "svg-2" }]
  ]
);

export { IconArrowNarrowRight as default };
//# sourceMappingURL=IconArrowNarrowRight.js.map
